class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (e) => {
      if (e.target.name == 'sort_by') {
        this.debouncedOnSubmit(e);
      }
    });
    this.querySelectorAll('[data-action="apply"]').forEach((element) => {
      element.addEventListener('click', this.debouncedOnSubmit.bind(this));
    });
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    // watchRangSliderChange();
    const drawer = document.querySelector('facet-drawer');
    drawer.bindEvents();
    drawer.connectedCallback();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const activeFacetsElementWrapper = document.querySelector(selector);
      if (activeFacetsElement && activeFacetsElementWrapper) {
        activeFacetsElementWrapper.innerHTML = activeFacetsElement.innerHTML;
        activeFacetsElementWrapper.classList.toggle(
          'hidden',
          activeFacetsElementWrapper.querySelectorAll('.active-facets__button').length === 0
        );
        document
          .querySelector('.facets-wrapper__custom')
          ?.classList.toggle(
            'has-active-facet',
            activeFacetsElementWrapper.querySelectorAll('.active-facets__button').length > 0
          );
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('facet-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target?.querySelector('.facets__selected');
    const sourceElement = source?.querySelector('.facets__selected');

    const targetElementAccessibility = target?.querySelector('.facets__summary');
    const sourceElementAccessibility = source?.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     // this.querySelectorAll('input').forEach((element) =>
//     //   element.addEventListener('change', this.onRangeChange.bind(this))
//     // );
//     // this.setMinAndMaxValues();
//     this.filterRange = this.querySelectorAll('[data-filter-range]');
//     this.filterRange.forEach((filter) => {
//       filter.addEventListener('keyup', (e) => {
//         this._updatePrice(e.currentTarget)
//       });
//       filter.addEventListener('change', (e) => {
//         this._updatePrice(e.currentTarget)
//       });
//       filter.addEventListener('mousemove', (e) => {
//         this._updatePrice(e.currentTarget)
//       });
//       filter.addEventListener('touchmove', (e) => {
//         this._updatePrice(e.currentTarget)
//       });
//     });
//   }

//   _updatePrice(element) {
//     const id = element.getAttribute("id");
//     const number1 = this.querySelector("#filter-price-from").value;
//     const number2 = this.querySelector("#filter-price-to").value;
//     const numberMax = this.querySelector("#filter-price-from").getAttribute("max");
//     const t = 0;
//     this.querySelector("#filter-price-from").setAttribute("max", number2);
//     this.querySelector("#filter-price-to").setAttribute("min", number1);
//     console.log(number1, number2);
//     // if (number1 >= number2) {
//     //   number1 = number2
//     // }
//     const subtotal =  number2 - number1;
//     const total = parseFloat((subtotal / numberMax ) * 100); 
//     const left = parseFloat((number1 / numberMax) * 100); 
//     document.getElementById("main-collection-filters").style.setProperty('--width', `${total}%`);
//     document.getElementById("main-collection-filters").style.setProperty('--left', `${left}%`);

//     const minInput = document.querySelector('[data-field-output-min]');
//     const maxInput = document.querySelector('[data-field-output-max]');
//     console.log(parseInt(minInput.innerHTML) <= parseInt(maxInput.innerHTML));
//     if (parseInt(minInput.innerHTML) <= parseInt(maxInput.innerHTML)) {
      
//     }
//     // document.querySelector('[data-field-price-min]').innerHTML = number1;
//     // document.querySelector('[data-field-price-max]').innerHTML = number2;
//     minInput.innerHTML = number1;
//     maxInput.innerHTML = number2;

//     if (id == 'filter-price-from') {
//       // number1.value = element.value
//     } else {
//       // number2.value = element.value
//     }
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('min', 0);
//     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min'));
//     const max = Number(input.getAttribute('max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

// customElements.define('price-range', PriceRange);


class PriceRange extends HTMLElement {
  constructor() {
      super();
      this.rangeSliderPrice();
      this.querySelectorAll('input').forEach((element) => {
          element.addEventListener('change', this.onRangeChange.bind(this))
      });
      this.setMinAndMaxValues();
      const numberS = this.querySelectorAll("input[type=number]");
      let value1 = numberS[0].value;
      let value2 = numberS[1].value ;

      this.updateDisplay(value1, value2);
  }       

  onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];

      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
  }

  rangeSliderPrice(){
      var rangeS = this.querySelectorAll("input[type=range]"),
          numberS = this.querySelectorAll("input[type=number]");
      
      rangeS.forEach((element) => {
          element.oninput = () => {
              var slide1 = parseFloat(rangeS[0].value),
                  slide2 = parseFloat(rangeS[1].value);

              if (slide1 > slide2) {
                  [slide1, slide2] = [slide2, slide1];
              }

              numberS[0].value = slide1;
              numberS[1].value = slide2;
              this.updateDisplay(numberS[0].value, numberS[1].value);
              this.updatePrice(slide1, slide2);
          }
      });

      // numberS.forEach((element) => {
      //     element.oninput = () => {
      //         var number1 = parseFloat(numberS[0].value),
      //             checkValue1 = number1 != number1,
      //             number2 = parseFloat(numberS[1].value),
      //             checkValue2 = number2 != number2;

      //         if(!checkValue1){
      //             rangeS[0].value = number1;
      //         }

      //         if(!checkValue2){
      //             rangeS[1].value = number2;
      //         }   

      //         if (number1 > number2) {
      //             this.updateDisplay(number2, number1);
      //             this.updatePrice(number2, number1);
      //         } else {
      //             this.updateDisplay(number1, number2);
      //             this.updatePrice(number1, number2);
      //         }
      //     }
      // });
  }

  updateDisplay(value1, value2) {
      const range = this.querySelector("input[type=range]");
      const priceSlideRangeContainer = this.querySelector('.facets__price--slide');
      const max = range.max 
      // const width = priceSlideRangeContainer.clientWidth;
      const width = 242;

      const leftSpace = (parseInt(value1) / parseInt(max)) * width + 'px'
      const rightSpace = (width - (parseInt(value2) / parseInt(max)) * width) + 'px'

      let range_slider = document.querySelector('.filter__price_max');
      let hint = document.querySelector('.label__filter-max');
      let range_slider_min = document.querySelector('.filter__price_min');
      let hint_min = document.querySelector('.label__filter-min');

      let thumbnWidth = 8;

      let offset = width / (parseInt(range_slider.max) - parseInt(range_slider.min));

      this.updatePosition(range_slider, offset, hint, thumbnWidth);
      this.updatePosition(range_slider_min, offset, hint_min, thumbnWidth);

      priceSlideRangeContainer.style.setProperty('--left-space', leftSpace)
      priceSlideRangeContainer.style.setProperty('--right-space', rightSpace)
  }

  updatePosition(range_slider, offset, hint, thumbnWidth) {
    hint.innerHTML = range_slider.value + '€';
    hint.style.top = range_slider.offsetHeight - 26 + 'px';
    hint.style.left = ((range_slider.valueAsNumber - parseInt(range_slider.min)) * offset - hint.offsetWidth / 2 - (range_slider.valueAsNumber / parseInt(range_slider.max) - parseInt(range_slider.min) - 0.5) * thumbnWidth) + 'px'; 
  }

  updatePrice(min, max) {
      const $currentMin = document.querySelector('.money--current-min');
      const $currentMax = document.querySelector('.money--current-max');
      const $labelMin = document.querySelector('.label__filter-min .text');
      const $labelMax = document.querySelector('.label__filter-max .text');

      if ($currentMin) $currentMin.innerHTML = min;
      if ($currentMax) $currentMax.innerHTML = max;
      if ($labelMin) $labelMin.innerHTML = min;
      if ($labelMax) $labelMax.innerHTML = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetSort extends HTMLElement {
  constructor() {
    super();
    this.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelectorAll('.facets__sort-option').forEach((element) => {
      element.addEventListener('click', this.onSortChange.bind(this));
    });
  }
  onSummaryClick(event) {
    const details = event.target.closest('details');
    const form = document.getElementById('FacetsWrapperDesktop');
    if (!details.hasAttribute('open') && form && form.classList.contains('active')) {
      document.querySelector('facet-open').click();
    }

    if(event.target.closest('.rock-section-sub-collection')) {
      event.target.closest('.rock-section-sub-collection').classList.toggle('open-sort-custom')
    }
  }
  onSortChange(event) {
    this.querySelectorAll('.facets__sort-option').forEach((element) => {
      element.classList.remove('selected');
    });
    event.currentTarget.classList.add('selected');
    let select = document.querySelector('facet-filters-form select[name="sort_by"]');
    select.value = event.currentTarget.dataset.value;
    select.dispatchEvent(
      new Event('input', {
        bubbles: true,
        cancelable: true,
      })
    );
    const details = event.target.closest('details');
    details.removeAttribute('open');

    if(event.target.closest('.rock-section-sub-collection')) {
      event.target.closest('.rock-section-sub-collection').classList.remove('open-sort-custom')
    }
  }
}
customElements.define('facet-sort', FacetSort);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  connectedCallback() {
    this.querySelectorAll('.mobile-facets__close').forEach((element) => {
      element.addEventListener('click', this.closeMenuDrawer.bind(this));
    });
    this.querySelectorAll('.mobile-facets__summary-close').forEach((button) =>
      button.addEventListener('click', this.onSubMenuClick.bind(this))
    );
  }
  onSubMenuClick(e) {
    e.stopPropagation();
    e.preventDefault();
    let button = e.currentTarget;
    let details = e.currentTarget.closest('details');
    if (button.classList.contains('is-animating')) return;
    button.classList.add('is-animating');
    button.classList.toggle('close-submenu');
    details.classList.toggle('menu-opening');
    let summary = e.currentTarget.closest('summary');
    let submenu = details.querySelector('.mobile-facets__submenu');
    const items = Array.from(details.querySelectorAll('.mobile-facets__item'));

    if (button.classList.contains('close-submenu')) {
      let totalDelay = 0;
      items.reverse().forEach((el, i) => {
        let delay = 0;
        totalDelay = delay;
        el.style.transition = `opacity 0.3s ease-in-out ${delay}ms`;
        el.style.opacity = 0;
      });
      const buttonShowMore = details.querySelector('.button-show-more');
      if (buttonShowMore) {
        buttonShowMore.style.transition = `opacity 0.2s ease-in-out`;
        buttonShowMore.style.opacity = 0;
      }
      submenu.style.height = submenu.scrollHeight + 'px';
      setTimeout(() => {
        submenu.style.height = '0';
        setTimeout(() => {
          summary.click();
          button.classList.remove('is-animating');
        }, 190);
      }, 100);
    } else {
      summary.click();
      submenu.style.height = submenu.scrollHeight + 'px';

      items.forEach((el, i) => {
        let delay = 0;
        el.style.transition = `opacity 0.3s ease-in-out ${delay}ms`;
        el.style.opacity = 1;
      });
      const buttonShowMore = details.querySelector('.button-show-more');
      if (buttonShowMore) {
        buttonShowMore.style.transition = `opacity 0.2s ease-in-out`;
        buttonShowMore.style.opacity = 1;
      }
      setTimeout(() => {
        submenu.style.height = '';
      }, 50);
      button.classList.remove('is-animating');
    }
  }
  showMoreFacets(event) {
    event.stopPropagation();
    const element = event.currentTarget;
    const isShow = element.classList.contains('show-more');
    const target = element.id ? document.querySelector(`[data-target="${element.id}"]`) : null;
    if (target) {
      if (!isShow) {
        target.classList.remove('overflow-hidden');
        element.classList.add('show-more');
      } else {
        target.classList.add('overflow-hidden');
        element.classList.remove('show-more');
      }
    }
  }
  checkFacetsListHeight() {
    const maxHeight = 290;
    const facetsList = document.querySelectorAll('.mobile-facets__list');
    facetsList.forEach((element) => {
      if (element.scrollHeight > maxHeight) {
        element.classList.add('overflow-hidden');
        let buttonShowmore = element.dataset.target ? document.querySelector(`#${element.dataset.target}`) : null;
        if (buttonShowmore) {
          buttonShowmore.classList.remove('hidden');
          buttonShowmore.addEventListener('click', this.showMoreFacets.bind(this));
        }
      }
    });
  }
  openMenuDrawer(event, elementToFocus = false) {
    const announcementBar = document.querySelector('.announcement-bar-section');
    if (announcementBar) {
      const announcementBarHeight = announcementBar.offsetHeight;
      this.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
    }
    const header = document.querySelector('header');
    if (header) {
      const headerHeight = header.offsetHeight;
      this.style.setProperty('--header-height', `${headerHeight}px`);
    }

    super.openMenuDrawer(event, elementToFocus);

    setTimeout(() => {
      this.checkFacetsListHeight();
      if (!this.rangeSliderInitial) {
        this.rangeSliderInitial = true;
        document.querySelector('range-slider').connectedCallback();
      }
    }, 500);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }
}

customElements.define('facet-drawer', FacetDrawer);

// function watchRangSliderChange() {
//   document.querySelector('range-slider').addEventListener('theme:range:updating', function (event) {
//     const rangeSlider = event.target;
//     const minInput = document.querySelector('[data-field-output-min]');
//     const maxInput = document.querySelector('[data-field-output-max]');
//     if (rangeSlider) {
//       var maxValue = Number(rangeSlider.dataset.seMaxValue);
//       if(maxValue < 0) {maxValue = 0;}
//       document.querySelector('[data-range-min]').innerHTML = rangeSlider.dataset.seMinValue;
//       document.querySelector('[data-range-max]').innerHTML = maxValue;
//       minInput.innerHTML = rangeSlider.dataset.seMinValue;
//       maxInput.innerHTML = maxValue;
//     }
//   });
// }

// watchRangSliderChange();
